<template>
    <div class="card-box">
        <div class="card-title">{{ card.name || '未命名卡片' }}</div>
        <div class="card-body">
            <div ref="chartRef" class="chart-container"></div>
            <div v-if="loading" class="loading-overlay">
                <el-icon class="is-loading"><Loading /></el-icon>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import { Loading } from '@element-plus/icons';
import request from '@/utils/request';

export default {
    name: 'CardChartPie',
    components: { Loading },
    props: {
        card: { type: Object, required: true },
        viewId: { type: String, default: '' },
        sectionIndex: { type: Number, default: -1 },
        cardIndex: { type: Number, default: -1 }
    },
    data() {
        return {
            loading: false
        };
    },
    created() {
        this.chartInstance = null;
    },
    mounted() {
        this.initChart();
        this.fetchData();
        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
        if (this.chartInstance) {
            this.chartInstance.dispose();
            this.chartInstance = null;
        }
    },
    methods: {
        initChart() {
            if (this.$refs.chartRef && !this.chartInstance) {
                this.chartInstance = echarts.init(this.$refs.chartRef);
            }
        },
        transformToPieData(rawData) {
            const params = this.card.params || {};
            const nameField = params.seriesName || 'name';
            const valueField = params.seriesData || 'value';

            const series = [];
            if (rawData && rawData.length) {
                for (const item of rawData) {
                    series.push({
                        name: item[nameField],
                        value: Number(item[valueField])
                    });
                }
            }
            return { series };
        },
        updateChart(pieData) {
            if (!this.chartInstance) {
                return;
            }

            const options = {
                color: ['#1890FF', '#91CB74', '#FAC858', '#EE6666', '#73C0DE', '#3CA272', '#FC8452', '#9A60B4', '#EA7CCC'],
                tooltip: { show: true, trigger: 'item' },
                legend: { show: true, bottom: 0 },
                series: [
                    {
                        type: 'pie',
                        radius: '60%',
                        center: ['50%', '45%'],
                        label: { show: true, formatter: '{b}: {d}%' },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        data: pieData.series
                    }
                ]
            };

            this.chartInstance.setOption(options);
        },
        async fetchData() {
            if (!this.viewId || this.sectionIndex < 0 || this.cardIndex < 0) {
                return;
            }

            this.loading = true;
            try {
                const res = await request({
                    url: '/dataview/getCardData',
                    method: 'post',
                    data: {
                        id: this.viewId,
                        sectionIndex: this.sectionIndex,
                        cardIndex: this.cardIndex
                    }
                });

                let rawData = [];
                if (res && res.code === 0 && res.meta && res.meta.data) {
                    rawData = res.meta.data;
                }

                const pieData = this.transformToPieData(rawData);
                if (!this.chartInstance) {
                    this.initChart();
                }
                this.updateChart(pieData);
            } catch (e) {
                console.error('获取饼图数据失败:', e);
            } finally {
                this.loading = false;
            }
        },
        handleResize() {
            if (this.chartInstance) {
                this.chartInstance.resize();
            }
        }
    }
};
</script>

<style scoped>
.card-box {
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    background: #fff;
    overflow: hidden;
}
.card-title {
    padding: 10px 14px;
    font-size: 14px;
    font-weight: bold;
    border-bottom: 1px solid #f0f2f5;
    background: #fafafa;
    color: #303133;
}
.card-body {
    position: relative;
    height: 240px;
    padding: 8px;
}
.chart-container {
    width: 100%;
    height: 100%;
}
.loading-overlay {
    position: absolute;
    top: 8px;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.9);
    font-size: 24px;
    color: #cdaf93;
}
</style>
